import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import { CONTACT } from "../lib/content";

export default function Hero({
  bgImage = "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/gfxrb2yy_After%201.jpeg",
  bgCredit = null,
}) {
  return (
    <section
      data-testid="home-hero"
      className="relative text-cream-light overflow-hidden"
      style={{ backgroundColor: "#2E2923" }}
    >
      <Nav transparentOnTop />
      {bgImage && (
        <>
          <img
            src={bgImage}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "linear-gradient(to right, rgba(46,41,35,0.92) 0%, rgba(46,41,35,0.80) 55%, rgba(46,41,35,0.55) 100%)",
            }}
          />
        </>
      )}
      <div
        className="relative max-w-[1280px] mx-auto px-6 md:px-10 pt-32 md:pt-40 pb-16 md:pb-24"
        style={{ minHeight: "720px", display: "flex", alignItems: "center" }}
      >
        <div className="grid grid-cols-12 gap-6 md:gap-8 w-full">
          <div className="col-span-12 md:col-span-11 md:col-start-2">
            <div className="text-[12px] tracking-[0.22em] uppercase mb-6 md:mb-8" style={{ color: "#B97842" }}>
              Tampa General Contractor · Since 2006
            </div>
            <h1
              className="font-serif font-medium tracking-tight leading-[1.08] mb-8 md:mb-10"
              style={{ fontSize: "clamp(30px, 5.4vw, 60px)", color: "#F7F2E9" }}
            >
              Tampa custom homes and renovations, built with engineering discipline.
            </h1>
            <p
              className="leading-relaxed mb-10 md:mb-12"
              style={{ fontSize: "17px", color: "rgba(247,242,233,0.90)", maxWidth: "640px" }}
            >
              BCPeabody is a family-owned, engineer-led general contractor. We build and renovate homes across Tampa Bay and bring 20 years of federal construction and disaster recovery experience to every project.
            </p>
            <div className="flex flex-wrap items-center gap-6 md:gap-8">
              <Link to="/contact" data-testid="hero-cta-start" className="btn-copper">
                Start a Project
              </Link>
              <Link
                to="/projects"
                data-testid="hero-cta-work"
                className="text-[13px] tracking-[0.14em] uppercase link-underline"
                style={{ color: "#F7F2E9" }}
              >
                See Our Work →
              </Link>
            </div>
          </div>
        </div>
      </div>
      {bgCredit && (
        <div className="absolute bottom-3 right-4 text-[10px] text-cream-light/60 tracking-wide">{bgCredit}</div>
      )}
      <span className="sr-only">{CONTACT.phone}</span>
    </section>
  );
}
